import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import MoreDetails from "app/pages/.shared/MoreDetails";
import DVAFParagraph from "./DVAFParagraph";
import "./MyInformations.scss";

const MyInformations = ({ dvaf, ficheProduitURI, email, phone, shop }) => {
	if (!dvaf || !dvaf.main || dvaf.main.length === 0) {
		return null;
	}

	const [showDetails, toggleDetails] = React.useState(false);
	const memoizedToggleDetails = React.useCallback(() => toggleDetails(!showDetails), [
		showDetails,
	]);
	const { main = [], optional = {} } = dvaf;

	const productUrl =
		typeof window !== "undefined" ? `${window.location.origin}/${shop}/${ficheProduitURI}` : "";

	return (
		<div className="my-informations">
			<div className="my-informations__container">
				<div className="my-informations__title">
					<FormattedMessage id="payment.myinformations.fa.title" />
				</div>
				<div className="my-informations__main">
					{main.map((line, index) => {
						let content = line;
						// replace placeholder with value
						content = content.replace("productUrl", `${productUrl}`);
						content = content.replace("callcenterEmail", email);
						content = content.replace("callcenterPhone", phone);

						return <DVAFParagraph key={index} content={content} />;
					})}
				</div>
				{optional.content && optional.content.length > 0 && (
					<div className="my-informations__optional">
						<a onClick={memoizedToggleDetails}>{optional.title}</a>
						<MoreDetails expanded={showDetails}>
							{optional.content.map((line, index) => (
								<DVAFParagraph key={index} content={line} />
							))}
						</MoreDetails>
					</div>
				)}
			</div>
		</div>
	);
};

MyInformations.defaultProps = {
	dvaf: {},
};

MyInformations.propTypes = {
	ficheProduitURI: PropTypes.string,
	email: PropTypes.string,
	phone: PropTypes.string,
	shop: PropTypes.string,
	dvaf: PropTypes.oneOfType([
		PropTypes.any,
		PropTypes.objectOf({
			main: PropTypes.array,
			optional: PropTypes.objectOf({ content: PropTypes.array, title: PropTypes.string }),
		}),
	]),
};

export default MyInformations;
